import React, {ReactNode} from 'react';
import {HeaderBody} from "./ModalHeaderStyles";

type IProps = {
    children: ReactNode
}


function ModalHeader({ children } : IProps) {
    return (
        <HeaderBody>
            {children}
        </HeaderBody>
    );
}

export default ModalHeader;
